import React, { useContext } from "react";
import ThemeContext from "../../../context";
import ColorsTheme from "../../../utils/colors";
import { fontstyle1, fontstyle3 } from "../../../utils/fonts";

export default function PriceSection() {
  const { theme } = useContext(ThemeContext);
  const colortheme = ColorsTheme[theme];

  return (
    <>
      <div className=" py-20 mt-2 sm:mt-20">
        <div className="lg:flex items-center justify-between">
          <div className=" lg:w-1/3 w-full">
            <h1
              className={`md:text-5xl text-3xl font-bold leading-10 mt-3 ${
                theme === "light" ? "text-gray-800" : colortheme.color
              }`}
              style={fontstyle1}
            >
              Pricing plan
            </h1>
            <p
              role="contentinfo"
              className={`text-base leading-5 mt-5 ${
                theme === "light" ? "text-gray-600" : colortheme.color
              }`}
              style={fontstyle1}
            >
              It’s free for everyone. we can’t wait to hear what you think
            </p>
          </div>
          <div className="xl:w-1/2 lg:w-7/12 relative w-full" role="list">
            <img
              src="https://i.ibb.co/0n6DSS3/bgimg.png"
              className="absolute w-full  -ml-12 -mt-24"
              alt="background circle images"
            />
            <div
              role="listitem"
              className="bg-white cursor-pointer shadow rounded-lg mt-3 flex relative z-30"
            >
              <div className="w-2.5  h-auto bg-indigo-700 rounded-tl-md rounded-bl-md" />
              <div className="w-full p-8">
                <div className="md:flex items-center justify-between">
                  <h2
                    className="text-2xl font-semibold leading-6 text-gray-800"
                    style={fontstyle1}
                  >
                    Starter
                  </h2>
                  <p
                    className="text-2xl md:mt-0 mt-4 font-semibold leading-6 text-gray-800"
                    style={fontstyle3}
                  >
                    FREE
                  </p>
                </div>
                <p
                  className="md:w-80 text-base leading-6 mt-4 text-gray-600"
                  style={fontstyle1}
                >
                  Full access to all features and no credit card required
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
